import styled from "styled-components";
const Wrapper = styled.div`
  .CountryCodeSelect {
    width: 100%;
    margin-bottom: -10px;
    .css-1pahdxg-control {
      border-color: #05ae4b;
      box-shadow: none;
      vertical-align: middle;
      line-height: 3;
    }
    .css-1s2u09g-control {
      height: 55px !important;
    }
    .css-1pahdxg-control:hover {
      border-color: #05ae4b;
      box-shadow: none;
      opacity: 0.7;
    }
  }
  . css-1okebmr-indicatorSeparator {
    display: none;
  }
  . css-1s2u09g-control {
    border: none;
    height: 55px;
  }
`;

export default Wrapper;
